module.exports = "<img class=\"act-image {{contentClass}}\" src=\"{{defaultImage}}\" (error)=\"onImgError($event)\" srcset=\"{{scaleFactorImage}}\" alt=\"\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/act-image/act-image.component.html
// module id = 1004
// module chunks = 22